import Grid from "@mui/material/Grid";
import React from "react";
import CharPDmg from "./Schaden/CharPDmg";
import CharMDmg from "./Schaden/CharMDmg";
import {useSignals} from "@preact/signals-react/runtime";
import AttributesNSC from "./Attributes/AttributesNSC";
import CharKVNSC from "./Verteidigung/CharKVNSC";
import CharMVNSC from "./Verteidigung/CharMVNSC";
import CharSVNSC from "./Verteidigung/CharSVNSC";
import {CharWUNDNSC} from "./Schwellen/CharWUNDNSC";
import CharBEWNSC from "./Schwellen/CharBEWNSC";
import CharTOTNSC from "./Schwellen/CharTOTNSC";
import CharPRNSC from "./Armor/CharPRNSC";
import CharMRNSC from "./Armor/CharMRNSC";
import CharSchaden from "./Schaden/CharSchaden";
import CharBlutschaden from "./Schaden/CharBlutschaden";
import CharWunden from "./Schaden/CharWunden";
import CharBlutwunden from "./Schaden/CharBlutwunden";
import Karma from "./Karma/Karma";
import KarmaMaxNSC from "./Karma/KarmaMaxNSC";
import CharErholungsprobenNSC from "./Schaden/CharErholungsprobenNSC";
import Mods from "./Mods/Mods";


export default function CharNSC() {
    useSignals()

    return <Grid className={'player'}>
        <AttributesNSC></AttributesNSC>
        <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
              spacing={1}
              alignItems="stretch">
            <CharKVNSC/>
            <CharMVNSC/>
            <CharSVNSC/>
            <CharWUNDNSC/>
            <CharBEWNSC/>
            <CharTOTNSC/>
        </Grid>
        <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
              spacing={1}
              alignItems="stretch">
            <Grid item xs={6} sm={3}>
                <CharPRNSC/>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharMRNSC/>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharSchaden/>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharBlutschaden/>
            </Grid>
        </Grid>
        <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
              spacing={1}
              alignItems="stretch">
            <Grid item xs={6} sm={3}>
                <CharWunden/>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharBlutwunden/>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharPDmg/>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharMDmg/>
            </Grid>
        </Grid>
        <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
              spacing={1}
              alignItems="stretch">
            <Grid item xs={6} sm={4}>
                <CharErholungsprobenNSC/>
            </Grid>
            <Grid item xs={6} sm={2}>
                <Karma></Karma>
            </Grid>
            <Grid item xs={6} sm={2}>
                <KarmaMaxNSC></KarmaMaxNSC>
            </Grid>
            <Grid item xs={6} sm={4}>
                <Mods/>
            </Grid>
        </Grid>
    </Grid>
}
